import { initializeApp } from "firebase/app";
import {
  getAuth,
  GoogleAuthProvider,
  sendPasswordResetEmail,
  GithubAuthProvider,
} from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getDatabase } from "firebase/database";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyD7iboqFZLbUIpKX-lwtkOF72YmZ2vZ6kA",
  authDomain: "collabpro-916b7.firebaseapp.com",
  projectId: "collabpro-916b7",
  storageBucket: "collabpro-916b7.appspot.com",
  messagingSenderId: "579805309985",
  appId: "1:579805309985:web:383db1bc9d5ecdcbf3c760",
  measurementId: "G-H5ZSBZY44X",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const GoogleProvider = new GoogleAuthProvider();
// const FacebookProvider = new FacebookAuthProvider();
const GithubProvider = new GithubAuthProvider();

// Initialize Firebase Authentication and get a reference to the service
const auth = getAuth(app);
const db = getFirestore(app);
const database = getDatabase(app);
const storage = getStorage(app);

export {
  app,
  auth,
  GoogleProvider,
  db,
  GithubProvider,
  sendPasswordResetEmail,
  database,
  storage,
  getAuth,
  getFirestore,
  getDatabase,
  getStorage,
};
